import React from "react";
import { Icon, Button, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import moment from "moment";
import CampaignCardHolder from "../../styles/campaignCardStyle";
import { formatCurrency } from "../../utils/formatCurrency";
import { getCategoryName, getCardThumb } from "../../utils/campaignDisplay";

const formatDate = (value) => (value ? moment(value).format("DD/MM/YYYY") : "—");

const ProposalCard = ({
  campaign,
  viewMode = "grid",
  onDetail,
  onEdit,
  onDelete,
  onArchive,
}) => {
  const { t, i18n } = useTranslation();
  const clientName = campaign.client && campaign.client.name;
  const brandName = campaign.brand && campaign.brand.name;
  const categoryName = getCategoryName(campaign.category, i18n.language);
  const creator = campaign.creator;
  const creatorName = creator
    ? `${creator.first_name || ""} ${creator.last_name || ""}`.trim()
    : "—";
  const thumb = getCardThumb(campaign);

  return (
    <CampaignCardHolder
      className={viewMode === "list" ? "campaignCard--list" : ""}
    >
      <div className="campaignCard__titlebar">
        <h3 className="campaignCard__title" title={campaign.name}>
          {campaign.name}
        </h3>
        <div className="campaignCard__edit" onClick={onEdit}>
          <Icon type="edit" />
        </div>
      </div>

      <div className="campaignCard__head">
        <div className="campaignCard__headtext">
          {clientName && (
            <p className="campaignCard__meta">
              {t("Client")}: {clientName}
            </p>
          )}
          {brandName && (
            <p className="campaignCard__meta">
              {t("Brand")}: {brandName}
            </p>
          )}
          <p className="campaignCard__meta campaignCard__meta--category">
            {t("Category")}: {categoryName || "—"}
          </p>
        </div>

        <div className="campaignCard__logo">
          <img src={thumb} alt={campaign.name} />
        </div>
      </div>

      <div className="campaignCard__dates">
        <span>
          <small>{t("Start")}:</small>
          {formatDate(campaign.start_date)}
        </span>
        <span>
          <small>{t("Finalization")}:</small>
          {formatDate(campaign.end_date)}
        </span>
      </div>

      <div className="campaignCard__infoRows">
        <div className="campaignCard__infoRow">
          <span>{t("Number of ads")}</span>
          <b>{campaign.contents_displays_total}</b>
        </div>
        <div className="campaignCard__infoRow">
          <span>{t("Campaign created by")}</span>
          <b>{creatorName}</b>
        </div>
        <div className="campaignCard__infoRow">
          <span>{t("For a total amount of")}</span>
          <b>{formatCurrency(campaign.total_price, campaign.currency, i18n.language)}</b>
        </div>
      </div>

      <div className="campaignCard__actions">
        <Button className="campaignCard__detail" onClick={onDetail}>
          {t("View proposal")}
        </Button>
        <Tooltip title={t("Delete")}>
          <Button icon="delete" onClick={onDelete} />
        </Tooltip>
        <Tooltip title={t("Archive")}>
          <Button icon="inbox" onClick={onArchive} />
        </Tooltip>
      </div>
    </CampaignCardHolder>
  );
};

export default ProposalCard;
